<template>
  <div />
</template>

<script>
import store from '@/store'

export default {
  beforeRouteEnter (to, from, next) {
    store.dispatch('AUTH/LOGOUT', store.getters.token)
      .then(() => next('/login'))
      .catch(() => next('/login'))
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Logout.vue